function timeStampFormatter(mss) {
    /* eslint-disable */
    const hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = parseInt((mss % (1000 * 60)) / 1000);
    return hours + ':' + minutes + ':' + seconds;
};

function formatTimestamp(timestamp) {
    // 创建一个新的 Date 对象
    const date = new Date(timestamp);

    // 获取年份，月份（注意：JavaScript 中的月份是从0开始计数的），日期
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 添加前导零
    const day = String(date.getDate()).padStart(2, '0');

    // 获取小时，分钟，秒
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // 返回格式化的字符串
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}



// 如果你想要分别独立检查每个占位符，并且它们不需要按特定顺序出现
function isMapSource(str) {
    const zoomRegex = /\{z\}/;
    const xRegex = /\{x\}/;
    const yRegex = /\{y\}/;
    return zoomRegex.test(str) && xRegex.test(str) && yRegex.test(str) && /^(http|https):\/\//.test(str);
}



export default {
    isMapSource,
    formatTimestamp,
    timeStampFormatter
}



// WEBPACK FOOTER //
// ./src/util/commonUtil.js